import { useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import React, { useCallback, useEffect, useRef, useState } from "react";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import {
  HeaderMenu,
  MobileMenu,
  StyledTonConnectButton,
} from "components/header/headerMenu/HeaderMenu";
import { AppLogo } from "components/appLogo";
import { SearchBar } from "components/header/headerSearchBar";
import {
  HeaderContent,
  HeaderExampleText,
  HeaderOptionalContent,
  HeaderWrapper,
  HeaderExampleLink,
  HeaderExampleTextWrapper,
  MobileMenuButton,
  MobileWalletWrapper,
} from "./styled";
import { EXAMPLE_ADDRESS } from "consts";
import { Outlet, useLocation } from "react-router-dom";
import { useNavigatePreserveQuery } from "lib/hooks/useNavigatePreserveQuery";

export const Header = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const matches = useMediaQuery("(min-width:900px)");
  const navigate = useNavigatePreserveQuery();
  const [example, setExample] = useState<string | undefined>(undefined);

  const location = useLocation();
  const topRef = useRef<null | HTMLDivElement>(null);

  const resetExample = useCallback(() => {
    setExample(undefined);
  }, []);

  useEffect(() => {
    topRef.current?.scrollIntoView();
  }, [location]);

  const manageClick = () => {
    navigate("/management");
  };

  return (
    <>
      <HeaderWrapper position="static" ref={topRef}>
        <HeaderContent>
          <HeaderOptionalContent>
            {!matches && (
              <MobileMenuButton aria-label="打开菜单" onClick={() => setMobileMenu(true)}>
                <MenuRoundedIcon />
              </MobileMenuButton>
            )}
            {matches && <AppLogo />}

            {matches && (
              <>
                <div className="manage_token" onClick={manageClick}>
                  管理代币
                </div>
                <HeaderMenu />
              </>
            )}
          </HeaderOptionalContent>
          {matches ? (
            <Box sx={{ width: "100%" }}>
              <SearchBar
                example={example}
                resetExample={resetExample}
                closeMenu={() => setMobileMenu(false)}
              />
              <HeaderExampleTextWrapper>
                <HeaderExampleText>
                  输入现有的代币合约地址
                  <HeaderExampleLink variant="body2" onClick={() => setExample(EXAMPLE_ADDRESS)}>
                    {" "}
                    例子
                  </HeaderExampleLink>
                </HeaderExampleText>
              </HeaderExampleTextWrapper>
            </Box>
          ) : (
            <MobileWalletWrapper>
              <StyledTonConnectButton />
            </MobileWalletWrapper>
          )}
          <MobileMenu showMenu={mobileMenu && !matches} closeMenu={() => setMobileMenu(false)} />
        </HeaderContent>
      </HeaderWrapper>
      <Outlet />
    </>
  );
};
